import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listOrgMembers, type OrgMember } from '../api/orgMembers.ts';

/**
 * The provider directory: every active member of the caller's own org. Backs the scheduling UI's
 * provider picker (`SchedulePage`'s "Viewing" select, `AppointmentFormDialog`'s own provider field) —
 * both render the same `email (role)` options from this one query rather than each fetching its own
 * copy, so TanStack Query's cache (keyed `['org-members']`, no parameters) serves the second caller
 * for free.
 *
 * Replaces the earlier per-id `useOrgMember` hook (`GET /api/orgs/members/:userId`, still a real route
 * for whatever future consumer needs a single lookup) now that both provider fields are a dropdown of
 * known-valid options rather than a pasted, unconfirmed id — see `ProviderConfirmation`'s removal in
 * the same change.
 */
export function useOrgMembers(): UseQueryResult<readonly OrgMember[]> {
  return useQuery({
    queryKey: ['org-members'],
    queryFn: ({ signal }) => listOrgMembers(signal),
  });
}
